const DateFilter = {
  thisWeek: 'thisWeek',
  all: 'all',
};

export default DateFilter;
